import { useQuery } from "@tanstack/react-query";
import { getChannelTrendStats } from "services/dashboard.service";

// period: 7d | 14d | 30d | 60d | 90d (default 30d), channel: optional channel filter
export const useChannelTrendStats = (period = "30d", channel, options = {}) => {
  return useQuery({
    queryKey: ["channel-trend-stats", period, channel],
    queryFn: () => getChannelTrendStats(period, channel),
    select: (res) => res?.data,
    ...options,
  });
};
